__turbopack_context__.v({
  "body": "E5U6DG_body",
  "container": "E5U6DG_container",
  "title": "E5U6DG_title",
});
